import React from 'react';
import { ComponentSeries, Role } from '@cambridgeassessment/lib-ee-commons';
import { StyledComponentHeaderContainer, StyledComponentTitle } from '../Details/styles';
import SamplingSeriesFC from './SamplingSeriesFC';

interface SamplingStartDateProps {
  series: ComponentSeries[];
  disabled: boolean;
  role: Role | null;
  onSalgoStartDateUpdate: (seriesId: ComponentSeries['id'], startDate: string) => void;
}

const SamplingStartDate = (props: SamplingStartDateProps): JSX.Element | null => {
  const seriesWithMarksSW = props.series.some((serie) => serie.marksSubmissionWindow);

  if (!seriesWithMarksSW) {
    return null;
  }

  return (
    <>
      <StyledComponentHeaderContainer>
        <StyledComponentTitle data-qa-id={'sampling-start-date-title'}>
          Sampling algorithm start date
        </StyledComponentTitle>
      </StyledComponentHeaderContainer>
      {props.series.map((it) => (
        <SamplingSeriesFC
          key={`salgo-${it._id}`}
          series={it}
          role={props.role}
          onSalgoStartDateUpdate={props.onSalgoStartDateUpdate}
          disabled={props.disabled}
        />
      ))}
    </>
  );
};

export default SamplingStartDate;
